import type {
  DegreeForProgramSwitcher as Degree,
  EnterpriseProgramForProgramSwitcher as EnterpriseProgram,
} from 'bundles/composable-page-header/components/program-switcher/types';

const sortDegreesByLaunchedDate = (degrees: Degree[]) => {
  const compareLaunchedDate = (a: Degree, b: Degree) => {
    const dateA = a.launchDate ? new Date(a.launchDate).getTime() : -1;
    const dateB = b.launchDate ? new Date(b.launchDate).getTime() : -1;
    return dateB - dateA;
  };

  const newDegrees = [...degrees];
  newDegrees.sort(compareLaunchedDate);
  return newDegrees;
};

// Sort EnterprisePrograms by launchedAt
const sortEnterpriseProgramsByLaunchedAt = (programs: EnterpriseProgram[]) => {
  const compareLaunchedAt = (a: EnterpriseProgram, b: EnterpriseProgram) => {
    return new Date(b.launchedAt ?? -1).getTime() - new Date(a.launchedAt ?? -1).getTime();
  };

  const newPrograms = [...programs];
  newPrograms.sort(compareLaunchedAt);
  return newPrograms;
};

export { sortDegreesByLaunchedDate, sortEnterpriseProgramsByLaunchedAt };
